import React from "react";
import {
  StyledIconButton,
  StyledToggleButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterList from "@mui/icons-material/FilterList";
import { useState } from "react";
import {
  StyledDialog,
  StyledDialogTitle,
} from "../../../components/StyledComponents/Dialog/Dialog";
import {
  BodyMedium,
  H6HeadlineSmall,
  H8TitleMedium,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledSelect } from "../../../components/StyledComponents/Inputs/Inputs.js";
import {
  DialogContent,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Autocomplete
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import { StyledMenuItem } from "../../../components/StyledComponents/Menu/Menu.tsx";
import { StyledFormControl } from "../../../components/StyledComponents/Inputs/Inputs.js";
import { usePostSiteConfig } from "../../queries/usePostSiteConfig.ts";
import useSiteAndGroupTreeContext from "../../../minerstatusV2/context/useSiteAndGroupTreeContext.js";
import { usePostDGConfig } from "../../queries/usePostDGConfig.ts";
import { useTheme } from "../../../ThemeContext/ThemeContext.js"; 
import { StyledTextField } from "../../../components/StyledComponents/Inputs/Inputs.js";
const AddPoolConfigDialogModal = (props) => {
  const { accessLists, configData, refetch } = props;
  const { colors } = useTheme();
  const {
    openAddConfigModal,
    setOpenAddConfigModal,
    mockData,
    setMockData,
    poolDataToEdit,
    editModeOn,
    setEditModeOn,
    setPoolDataToEdit,
  } = usePoolsPageContext();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const formRef = React.useRef();
  console.log(poolDataToEdit, "poolDataToEdit");
  const { mutate: postSiteConfig } = usePostSiteConfig();
  const { mutate: postGroupConfig } = usePostDGConfig();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: {
      accessLists: "",
      password: "",
      worker: "",
    },
  });

  React.useEffect(() => {
    if (poolDataToEdit) {
      console.log(
        "poolDataToEditInUseEffect",
        poolDataToEdit
      );
      const cleanedAccessLists =
        `${poolDataToEdit.url},${poolDataToEdit.user}`.replace(
          /\\/g,
          ""
        );
      reset({
        accessLists: cleanedAccessLists.trim(),
        password: poolDataToEdit.password,
        worker:
          poolDataToEdit.worker,
      });
      setValue(
        "accessLists",

        `${poolDataToEdit.url},${poolDataToEdit.user}`
      );
    } else {
      reset({
        accessLists: "",
        password: "",
        worker: "",
      });
    }
  }, [poolDataToEdit, reset, setValue]);

  const onSubmit = (data) => {
    console.log("data", data);
    if (editModeOn) {
      const dataToBeModified = configData?.poolCfg?.map(
        (pool, index) => {
          console.log("pool data pfg", pool);
          if (index === poolDataToEdit.index) {
            const [url, user] = data.accessLists.split(",");
            return {
              url: url,
              user: user,
              pass: data.password,
              worker: data.worker,
            };
          } else {
            return pool;
          }
        }
      );
      console.log("dataToBeModified", dataToBeModified);
      if (siteSelectedName && !groupSelectedName) {
        const siteDataModified = {
          ...configData,
          poolCfg: dataToBeModified,
        };
        postSiteConfig(
          {
            siteName: siteSelectedName,
            config: {
              ztp: {
                ...siteDataModified,
              },
            },
          },
          {
            onSuccess: async (res) => {
              if (res.status === "error") {
                setToastOpen(true);
                setToastMessage(
                  `Error editing pool ${
                    poolDataToEdit.index + 1
                  } from ${siteSelectedName}`
                );
                await refetch();
                setOpenAddConfigModal(false);
              } else {
                setToastOpen(true);
                setToastMessage(
                  `Pool ${
                    poolDataToEdit.index + 1
                  } edited from ${siteSelectedName}`
                );
                await refetch();
                setEditModeOn(false);
                setPoolDataToEdit(null);
                setOpenAddConfigModal(false);
                reset();
              }
            },
            onError: (err) => {
              setToastOpen(true);
              setEditModeOn(false);
              setToastMessage(
                `Error editing pool ${
                  poolDataToEdit.index + 1
                } from ${siteSelectedName}`
              );
              setPoolDataToEdit(null);
              setOpenAddConfigModal(false);
              reset();
            },
          }
        );
      } else {
        const groupDataModified = {
          ...configData,
          poolCfg: dataToBeModified,
        };
        postGroupConfig(
          {
            siteName: siteSelectedName,
            dgname: groupSelectedName,
            config: {
              ztp: {
                ...groupDataModified,
              },
            },
          },
          {
            onSuccess: async (res) => {
              if (res.status === "error") {
                setToastOpen(true);
                setToastMessage(
                  `Error editing pool ${
                    poolDataToEdit.index + 1
                  } from ${siteSelectedName} in group ${groupSelectedName}`
                );
                await refetch();
                setOpenAddConfigModal(false);
              } else {
                setToastOpen(true);
                setToastMessage(
                  `Pool ${
                    poolDataToEdit.index + 1
                  } edited from ${siteSelectedName} in group ${groupSelectedName}`
                );
                await refetch();
                setEditModeOn(false);
                setPoolDataToEdit(null);
                setOpenAddConfigModal(false);
                reset();
              }
            },
            onError: (err) => {
              setToastOpen(true);
              setEditModeOn(false);
              setToastMessage(
                `Error editing pool ${
                  poolDataToEdit.index + 1
                } from ${siteSelectedName} in group ${groupSelectedName}`
              );
              setPoolDataToEdit(null);
              setOpenAddConfigModal(false);
              reset();
            },
          }
        );
      }
    } else {
      const poolData = configData.poolCfg || [];
      const [url, user] = data.accessLists.split(",");
      const newPoolData = {
        url: url,
        user: user,
        pass: data.password,
        worker: data.worker,
      };
      console.log("newPoolData", newPoolData);

      const finalPoolCfg = [...poolData, newPoolData];
      const siteDataModified = {
        ...configData,
        poolCfg: finalPoolCfg,
      };
      if (siteSelectedName && !groupSelectedName) {
        postSiteConfig(
          {
            siteName: siteSelectedName,
            config: {
              ztp: {
                ...siteDataModified,
              },
            },
          },
          {
            onSuccess: async (res) => {
              if (res.status === "error") {
                setToastOpen(true);
                setToastMessage(
                  `Error adding pool configuration to ${siteSelectedName}`
                );
                await refetch();
                setOpenAddConfigModal(false);
                reset();
              } else {
                setToastOpen(true);
                setToastMessage(
                  `Pool configuration added to ${siteSelectedName} successfully`
                );
                await refetch();
                setOpenAddConfigModal(false);
                reset();
              }
            },
            onError: (err) => {
              setToastOpen(true);
              setToastMessage(
                `Error adding pool configuration to ${siteSelectedName}`
              );
              setOpenAddConfigModal(false);
              reset();
            },
          }
        );
      } else {
        postGroupConfig(
          {
            siteName: siteSelectedName,
            dgname: groupSelectedName,
            config: {
              ztp: {
                ...siteDataModified,
              },
            },
          },
          {
            onSuccess: async (res) => {
              if (res.status === "error") {
                setToastOpen(true);
                setToastMessage(
                  `Error adding pool configuration to ${siteSelectedName} in group ${groupSelectedName}`
                );
                await refetch();
                setOpenAddConfigModal(false);
                reset();
              } else {
                setToastOpen(true);
                setToastMessage(
                  `Pool configuration added to ${siteSelectedName} in group ${groupSelectedName} successfully`
                );
                await refetch();
                setOpenAddConfigModal(false);
                reset();
              }
            },
            onError: (err) => {
              setToastOpen(true);
              setToastMessage(
                `Error adding pool configuration to ${siteSelectedName} in group ${groupSelectedName}`
              );
              setOpenAddConfigModal(false);
              reset();
            },
          }
        );
      }
    }
  };

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"lg"}
      open={openAddConfigModal}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H6HeadlineSmall style={{ textAlign: "left" }}>
            {editModeOn
              ? `Edit pool configuration ${
                  poolDataToEdit?.index + 1
                }`
              : `Add a new configuration`}
          </H6HeadlineSmall>
          <StyledIconButton 
            colors={colors}
            onClick={() => {
              setOpenAddConfigModal(false);
              setEditModeOn(false);
              setPoolDataToEdit(null);
              reset();
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form
          ref={formRef}
          onSubmit={handleSubmit(onSubmit)}
        >
          <fieldset
            disabled={
              !accessLists || accessLists.length === 0
            }
            style={{ border: 0, padding: 0, margin: 0 }}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={8}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="url-details-container"
              >
                <H8TitleMedium>URL</H8TitleMedium>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexGrow={1}
                >
                  <StyledFormControl colors={colors}
                    fullWidth
                    margin="none"
                  >
                    <InputLabel
                      errors={Boolean(errors.accessLists)}
                    >
                      Select URL
                    </InputLabel>
                    <Controller
                      name="accessLists"
                      control={control}
                      rules={{
                        required: "URL is required",
                        validate: (value) =>
                          (value && value !== "") ||
                          "URL is required",
                      }}
                      render={({ field }) => (
                        <StyledSelect
                          colors={colors}
                          {...field}
                          sx={{ minHeight: "3.5rem" }}
                          variant="outlined"
                          label="Select URL"
                          fullWidth
                          value={field.value}
                          placeholder="URL"
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: "250px",
                                maxWidth: "12rem",
                                overflowY: "auto",
                                backgroundColor: colors?.background?.paper,    
                                color: colors?.text?.primary,
                              },
                            },
                          }}
                          onChange={(event) =>
                            field.onChange(
                              event.target.value
                            )
                          }
                        >
                          {accessLists?.map(
                            (accessList) => (
                              <StyledMenuItem colors={colors}
                                value={accessList}
                              >
                                <BodyMedium noWrap>
                                  {" "}
                                  {`${accessList}`}
                                </BodyMedium>
                              </StyledMenuItem>
                            )
                          )}
                        </StyledSelect>
                      )}
                    />
                    {(!accessLists ||
                      accessLists.length === 0) && (
                      <span
                        style={{
                          color: colors?.error?.main,      
                          fontSize: "0.75rem",
                          marginTop: 4,
                        }}
                      >
                        No whitelist URL and user entries
                        found.
                      </span>
                    )}
                    {errors.accessLists && (
                      <span
                        style={{
                          color: colors?.error?.main, 
                          fontSize: "0.75rem",
                          marginTop: 4,
                        }}
                      >
                        {errors.accessLists.message}
                      </span>
                    )}
                  </StyledFormControl>
                </Box>
              </Box>

              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="url-details-container"
              >
                <H8TitleMedium>Password</H8TitleMedium>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexGrow={1}
                >
                  <StyledFormControl colors={colors}  
                    fullWidth
                    margin="none"
                  >
                    <Controller
                      name="password"
                      control={control}
                      rules={{
                        pattern: {
                          value:
                            /^[A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
                          message:
                            "Password can contain letters, numbers, and special characters.",
                        },
                        maxLength: {
                          value: 128,
                          message:
                            "Password must be 128 characters or fewer",
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField
                          colors={colors}
                          {...field}
                          variant="outlined"
                          label="Enter password"
                          fullWidth
                          onChange={(event) => {
                            const asciiOnlyTrimmed = event.target.value
                              .replace(/[^\x00-\x7F]/g, "") // remove non-ASCII characters
                              .trim();                      // trim leading/trailing whitespace
                            field.onChange(asciiOnlyTrimmed);
                          }}
                          error={!!errors.password}
                          helperText={
                            errors.password?.message
                          }
                        />
                      )}
                    />
                  </StyledFormControl>
                </Box>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="url-details-container"
              >
                <H8TitleMedium>
                  Worker Identifier
                </H8TitleMedium>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexGrow={1}
                >
                  <StyledFormControl colors={colors}
                    fullWidth
                    margin="none"
                  >
                    <Controller
                      name="worker"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                      <Autocomplete
                        {...field}
                        freeSolo
                        options={['IPAddress', 'ChassisSerialNo']}
                        value={field.value || null}
                        onChange={(_, newValue) => field.onChange(newValue)}
                        onInputChange={(_, newInputValue) => field.onChange(newInputValue)}
                        disableClearable={false}
                        disableCloseOnSelect={false}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) => option === value}
                        ListboxProps={{
                          sx: {
                            maxHeight: "250px",
                            overflowY: "auto",
                            backgroundColor: colors?.background?.paper,  
                                "&.selected": {
                                  backgroundColor:
                                    colors?.primary?.light,
                                },
                                color: colors?.text?.primary,
                          },
                        }}
                        slotProps={{
                          popupIndicator: {
                            sx: { color: colors.text.muted , 
                            '&:hover': { color: colors.text.primary },
                          }
                          },
                          clearIndicator: {
                            sx: {
                              color: colors.text.muted,
                              '&:hover': { color: colors.text.primary },
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <StyledTextField  
                            colors={colors}
                            {...params}
                            label="Add Worker Identifier"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              readOnly: false,
                            }}
                          />
                        )}
                      />
                      )}
                      />
                  </StyledFormControl>
                </Box>
              </Box>

              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
                gap={4}
                className="action-button-container"
              >
                <PrimaryButton colors={colors}
                  disabled={
                    !isValid ||
                    !accessLists ||
                    accessLists.length === 0
                  }
                  type="submit"
                  onClick={handleSubmit(onSubmit)}
                >
                  Apply
                </PrimaryButton>
              </Box>
            </Box>
          </fieldset>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};

const AddPoolConfigDialog = (props) => {
  const { accessLists, configData, refetch } = props;
  return (
    <>
      <AddPoolConfigDialogModal
        accessLists={accessLists}
        configData={configData}
        refetch={refetch}
      />
    </>
  );
};

export default AddPoolConfigDialog;
